// extracted by mini-css-extract-plugin
export var askRedoIcon = "_g-f";
export var askRedoTag = "_g-8";
export var askRedoText = "_g-e";
export var brandGroup = "_g-2";
export var chevron = "_g-p";
export var chevronActive = "_g-q";
export var chevronDown = "_g-l";
export var divider = "_g-r";
export var exitIcon = "_g-b";
export var exitTag = "_g-7";
export var exitText = "_g-d";
export var header = "_g-0";
export var logo = "_g-4";
export var navBar = "_g-1";
export var productIcon = "_g-9";
export var productName = "_g-c";
export var productTag = "_g-5";
export var profileAvatar = "_g-h";
export var profileGroup = "_g-g";
export var profileImage = "_g-i";
export var profileInitials = "_g-j";
export var progressFill = "_g-t";
export var progressTrack = "_g-s";
export var rightGroup = "_g-3";
export var stepLabel = "_g-n";
export var stepLabelActive = "_g-o";
export var stepLabels = "_g-m";
export var storeName = "_g-k";
export var themeIcon = "_g-a";
export var themeTag = "_g-6";